<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex xs12 sm6 md12>
          <v-text-field label="Name" v-model="itemData.name"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field type="number" label="Price" v-model="itemData.price"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-text-field type="number" label="Commission" v-model="itemData.commission"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-select
            :items="usersList"
            v-model="itemData.users_id"
            label="Select user"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.roles | normalizeRoles }}
            </template>
            <template slot="selection" slot-scope="props">
              {{ props.item.name }} - {{ props.item.roles | normalizeRoles }}
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12 sm6 md12>
          <v-combobox
            v-if="categoriesList"
            v-model="selectedCategory"
            :loading="loading"
            :items="categoriesList"
            :search-input.sync="categorySearch"
            hide-selected
            label="Select category"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.text }}
            </template>
            <template slot="selection" slot-scope="props">
              {{ props.item.text }}
            </template>
            <template v-slot:no-data>
              <v-list-tile class="pointer">
                <v-list-tile-content>
                  <v-list-tile-title @click="addCategory">
                    No results matching "<strong>{{ categorySearch }}</strong>". <kbd>Click</kbd> to create a new category
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <template v-slot:append-outer>
              <v-checkbox class="checkboxParentCategory" v-model="setParentId" :label="`Set parent category`"></v-checkbox>
            </template>
          </v-combobox>
        </v-flex>

        <v-flex xs12>
          <v-combobox
            v-if="categoriesList && setParentId"
            v-model="selectedParentCategory"
            :loading="loading.categories"
            :items="excludeSelectedCategory"
            hide-selected
            label="Select parent category"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.text }}
            </template>
            <template slot="selection" slot-scope="props">
              {{ props.item.text }}
            </template>
          </v-combobox>
        </v-flex>
        <!--<v-flex xs12 sm6 md12 class="text-md-left">-->
          <!--<ItemCheckList v-if="itemLoaded" :item-id="itemData.id" :item-type="itemType"></ItemCheckList>-->
        <!--</v-flex>-->
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemDataDecorator">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import itemTypesMixins from '@/mixins/ItemTypes'
  import ItemCheckList from '@/components/ItemCheckList'
  import usersAPI from '@/api/user'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    components: { ItemCheckList },
    mixins: [ dialogMixins, itemTypesMixins ],
    data () {
      return {
        resource: 'services',
        usersList: [],
        categorySearch: null,
        selectedCategory: null,
        selectedParentCategory: null,
        setParentId: false,
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        products: 'allProducts',
        categoriesList: 'productsCategories',
        categoryById: 'getProductCategoryById'
      }),
      itemType () {
        return this.serviceTypeID
      },
      excludeSelectedCategory () {
        if (this.selectedCategory === null) return this.categoriesList
        return _.filter(this.categoriesList, (c) => { return c.id !== this.selectedCategory.id })
      }
    },
    // TODO move to mixins along with EditProducts
    filters: {
      normalizeRoles (items) {
        return items && items.length > 0 ? items.map(mapping => mapping.name).join() : ''
      }
    },
    watch: {
      itemData: {
        handler (service) {
          this.selectedUser = service.users_id
          this.selectedCategory = this.categoryById(service.categories_id)
        },
        deep: true
      },
      selectedCategory (c) {
        if (c.parent_id === null) {
          this.setParentId = false
          this.selectedParentCategory = null
          return
        }
        this.setParentId = true
        this.selectedParentCategory = this.categoryById(parseInt(this.selectedCategory.parent_id))
      },
      selectedParentCategory (p) {
        if (this.selectedCategory === null || p === null) return
        this.editCategory()
      },
      setParentId (v) {
        if (v === false && this.selectedCategory !== null && this.selectedParentCategory !== null) {
          this.selectedParentCategory = null
          this.editCategory()
        }
      }
    },
    methods: {
      addCategory () {
        this.loading = true
        this.$store.dispatch('createProductCategory', this.categorySearch).then(() => {
          this.loading = false
          this.$store.dispatch('getProductsCategories')
        })
      },
      editCategory () {
        this.loading = true
        this.$store.dispatch('editProductCategory', { id: this.selectedCategory.id,
          parent_id: this.selectedParentCategory !== null ? this.selectedParentCategory.id : null
        }).then(() => {
          this.$store.dispatch('getProductsCategories')
          this.loading = false
        }, () => {
          this.$store.dispatch('getProductsCategories')
          this.loading = false
        })
      },
      editItemDataDecorator () {
        if (this.selectedCategory) {
          this.itemData.categories_id = this.selectedCategory.id
        }

        this.editItemData()
      }
    },
    created () {
      usersAPI.loadUsers().then(result => {
        this.usersList = result
      }, () => {})
    }
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// AppEditProductsDialog.vue?3178ee87